import {useMutation, useQueryClient} from 'react-query';
import {patchGuarantor} from './patchGuarantor';

const usePatchGuarantor = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (payload: IGuarantorPayload) => patchGuarantor(payload),

    onSuccess: () => {
      queryClient.invalidateQueries('loan-request-rule');
      queryClient.invalidateQueries('get-list-loan-request');
      queryClient.invalidateQueries('loan-rule');
    },
  });

  return {
    patchGuarantor: mutation.mutate,
    isPatchGuarantorLoading: mutation.isLoading,
  };
};

export default usePatchGuarantor;
